import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="text-center max-w-lg">
          <p className="text-7xl md:text-9xl font-black text-primary-500 font-label leading-none">404</p>
          <h1 className="text-2xl md:text-3xl font-black text-foreground-950 mt-4">页面不存在</h1>
          <p className="text-sm md:text-base text-foreground-500 mt-3">
            你要访问的页面可能已被删除、改名，或链接有误。不妨返回首页，继续浏览最新的娱乐黑料与资讯。
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3 mt-8">
            <Link
              to="/"
              className="px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              返回首页
            </Link>
            <Link
              to="/search"
              className="px-6 py-3 rounded-md bg-background-100 text-foreground-800 text-sm font-medium hover:bg-background-200 transition-colors whitespace-nowrap"
            >
              搜索内容
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}